export const formatOrganisationData = (organisation) => ({
  id: organisation.id,
  organisationName: organisation.organisation_name,
  status: organisation.status,
  cnt_project: organisation.projects,
  updatedAt: new Date(organisation?.updated_at).getTime(),
  personalProjectsCount: organisation.personal_projects,
  isDashboardPortfolioEnabled: organisation.is_user_has_access_to_master_dashboard,
  isMfaEnabled: organisation.is_mfa_enabled ?? false,
  hasProjectRelations: organisation.has_project_relations ?? false,
  hasPersonalJournals: organisation.has_personal_journals ?? false,
});
